import { render, staticRenderFns } from "./dividend.vue?vue&type=template&id=022bf557&scoped=true"
import script from "./dividend.vue?vue&type=script&lang=js"
export * from "./dividend.vue?vue&type=script&lang=js"
import style0 from "./dividend.vue?vue&type=style&index=0&id=022bf557&prod&lang=scss"
import style1 from "./dividend.vue?vue&type=style&index=1&id=022bf557&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022bf557",
  null
  
)

export default component.exports